import React from 'react'
import { createPortal } from 'react-dom'
import ProjectDescriptionModal from './Modal'
import clock from '../assets/img/clock-time.svg'
import itDeveloper from '../assets/img/it-developer.svg'
import editDocument from '../assets/img/edit-document.svg'
import { urlFor } from '../client'

const ProjectDescription = React.memo(({
    show,
    onHide,
    title,
    introduction,
    projectLogo,
    description,
    links,
    tasks,
    role,
    period
}) => {
    console.log(projectLogo)
    const linksToShow = []
    for (const [key, link] of Object.entries(links)) {
        linksToShow.push({
            title: key,
            href: link
        })
    }
    linksToShow.push({ title: 'Contactez moi', href: '#connect' })

    return createPortal(
        <div>
            <ProjectDescriptionModal
                title={title}
                onHide={onHide}
                links={linksToShow}
                image={projectLogo ? urlFor(projectLogo) : ''}
            >
                <>
                    <div className="w-100">
                        <h3 className="fw-bold">Le projet</h3>
                        <p>{introduction}</p>
                        <ul className='list-unstyled fs-6'>
                            {role && <li className='fw-semibold mb-1 d-flex align-items-center'><img src={itDeveloper} className="me-2" style={{ width: "30px" }} alt='it developer' />{role}</li>}

                            {tasks && (
                                <li className="d-flex gap-2 align-items-start flex-md-row">
                                    <img src={editDocument} className="me-2" style={{ width: "40px" }} alt='edit file icon' />
                                    <ul className='list-unstyled'>
                                        {tasks.map(task => (
                                            <li className='fw-semibold mb-1 d-flex align-items-center' key={task}>
                                                {task}
                                            </li>
                                        ))}
                                    </ul>
                                </li>
                            )}
                            {period && <li className='fw-semibold'><img src={clock} className="me-2" style={{ width: "30px" }} alt='clock icon' />{period}</li>}
                        </ul>
                    </div>

                    {description?.map(des => (
                        <div key={des._key} className='mb-3 px-3'>
                            {des.title && <h3 className='fw-bold'>{des.title}</h3>}
                            {des.content && <p className='lh-4'>{des.content}</p>}
                            {des.imgUrl && <img src={urlFor(des.imgUrl)} alt="project description" className="img-fluid" />}
                            {/* <div>
                                    {des?.images.map((v, i) => {
                                        return <img src={urlFor(v)} alt={i} key={i} className={`${i < des.images.length ? 'mb-2' : ''} img-fluid`} />
                                    })}
                                </div>
                            */}
                        </div>
                    ))}
                </>
            </ProjectDescriptionModal>
        </div>,
        document.body
    )
})

export default ProjectDescription